/** Primary production app hostname. */
export const APP_DOMAIN = 'velocity.exchange';

/** Full production app URL with protocol. */
export const APP_URL = `https://${APP_DOMAIN}`;

/** Staging app hostname and URL. */
const STAGING_APP_DOMAIN = 'beta.velocity.exchange';

/** Build a full app URL from an optional path or query string. */
export function getAppUrl(path = ''): string {
	if (!path) return APP_URL;
	return `${APP_URL}${path.startsWith('/') || path.startsWith('?') ? path : `/${path}`}`;
}

/** Referral link display format (hostname + path, no protocol). */
export function getReferralLinkDisplay(accountName: string): string {
	return `${APP_DOMAIN}/ref/${accountName}`;
}

/** Whether the host is a Velocity Exchange app domain. */
export function isVelocityAppHost(host: string): boolean {
	const hostname = host.split(':')[0];
	return (
		hostname === APP_DOMAIN ||
		hostname === STAGING_APP_DOMAIN ||
		hostname.endsWith(`.${APP_DOMAIN}`)
	);
}
